(function () {
    class Zepter_V2_Home_MainSlider {
        constructor() {
            this.elWrapper = document.getElementById("V2_Home_MainSlider_Wrapper");
            this.elSwiper = document.getElementById("V2_Home_MainSlider_Swiper");
            // Jeśli wymagane kontenery nie zostały odnalezione w DOM
            if (!this.elWrapper || !this.elSwiper) {
                // Zakończ działanie tej klasy
                return;
            }
            // Uruchom slider
            this.SetupSwiper();
        }
        SetupSwiper() {
            // Ustal element z paginatorem
            const elPagination = document.getElementById("V2_Home_MainSlider_Swiper_Pagination");
            // Jeśli element z paginatorem istnieje
            if (elPagination) {
                // Ukryh element z paginatorem na starcie
                elPagination.style.visibility = "hidden !important";
                elPagination.style.opacity = "0";
            }
            // Funkcja ustawiająca paginator
            const fnPagination = (swiper) => {
                // Jeśli paginator istnieje
                if (elPagination) {
                    // Przetwarzaj elementy paginatora
                    elPagination.querySelectorAll("span").forEach((elBullet, bulletIndex) => {
                        // Wygaś element paginatora
                        //elBullet.classList.remove("swiper-pagination-bullet-active")
                        //elBullet.classList.remove("swiper-pagination-current")
                        //elBullet.removeAttribute("aria-current")
                        // Jeśli ten element paginatora odpowiada aktualnie widocznemu slajdowi
                        if (bulletIndex == swiper.realIndex) {
                            // Podświetl element paginatora
                            //elBullet.classList.add("swiper-pagination-bullet-active")
                            //elBullet.classList.add("swiper-pagination-current")
                            //elBullet.setAttribute("aria-current", "true")
                        }
                        // Jeśli element jest nadmiarowy (oznacza zduplikowane slajdy do opcji 'loop' slidera)
                        //if (bulletIndex >= swiper.slides.length - 2) {
                        //    // Ukryj element nadmiarowy
                        //    elBullet.style.display = "none"
                        //}
                    });
                    // Jeśli paginator jest ukryty (stan startowy)
                    if (elPagination.style.visibility != "visible") {
                        // Uczyń paginator widocznym
                        elPagination.style.visibility = "visible";
                        elPagination.style.opacity = "1";
                    }
                }
            };
            // Uruchom swiper slider
            const swiper = new Swiper(this.elSwiper, {
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                autoplay: {
                    disableOnInteraction: true,
                    delay: 4000,
                },
                pagination: {
                    el: document.getElementById("V2_Home_MainSlider_Swiper_Pagination"),
                    bulletClass: 'V2_Home_MainSlider_Swiper_Pagination_Item_Wrapper',
                    bulletActiveClass: 'V2_Home_MainSlider_Swiper_Pagination_Item_Wrapper_Active',
                    clickable: true,
                },
                navigation: {
                    nextEl: document.getElementById("V2_Home_MainSlider_Swiper_Button_Next"),
                    prevEl: document.getElementById("V2_Home_MainSlider_Swiper_Button_Prev"),
                },
                on: {
                    afterInit: function (swiper) {
                        fnPagination(swiper);
                        window.setTimeout(() => {
                            fnPagination(swiper);
                        }, 1000);
                    },
                    activeIndexChange: function (swiper) {
                        fnPagination(swiper);
                    },
                },
            });
        }
    }
    new Zepter_V2_Home_MainSlider();
})();
//# sourceMappingURL=Home_MainSlider.js.map